<template>
  <g id="Group_7134" data-name="Group 7134" transform="translate(-382.065 -24.565)">
    <rect id="Rectangle_1664" data-name="Rectangle 1664" width="36" height="2" rx="1" transform="translate(383.479 24.565) rotate(45)"/>
    <rect id="Rectangle_1665" data-name="Rectangle 1665" width="36" height="2" rx="1" transform="translate(382.065 50.021) rotate(-45)"/>
  </g>
</template>
